var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("navbar"),
      _vm._m(0),
      _c("div", { staticClass: "content table-content" }, [
        _c("div", { staticClass: "table-content-item" }, [
          _c(
            "div",
            { staticClass: "table-content-item-side" },
            [
              _c("h3", { staticClass: "card-title" }, [
                _c(
                  "label",
                  [
                    _vm._v(" 商品销量订单 "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: "已发货之后的，不含退货，退款",
                          placement: "top",
                        },
                      },
                      [_c("i", { staticClass: "el-icon-question" })]
                    ),
                  ],
                  1
                ),
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "staff-button-list" },
                  [
                    _c("el-button", {
                      staticClass: "download-table",
                      attrs: { size: "small", icon: "el-icon-download" },
                      on: {
                        click: function ($event) {
                          return _vm.onDownload("topOrder")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("search-com-company", {
                staticClass: "search-company",
                attrs: {
                  type: _vm.topOrder.type,
                  dateArr: _vm.topOrder.dateArr,
                },
                on: { outputSearchData: _vm.receiveSearchData },
              }),
              _c(
                "div",
                { attrs: { id: "top-order" } },
                [
                  _c("top-sale", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.topOrder.loading,
                        expression: "topOrder.loading",
                      },
                    ],
                    attrs: {
                      documentId: "top-order",
                      config: _vm.topOrder.config,
                      dataList: _vm.topOrder.dataList,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table-content-item-side" },
            [
              _c("h3", { staticClass: "card-title" }, [
                _c(
                  "label",
                  [
                    _vm._v(" 各类目的销售情况 "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: "统计商品不含赠品",
                          placement: "top",
                        },
                      },
                      [_c("i", { staticClass: "el-icon-question" })]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "staff-button-list" },
                  [
                    _c("el-button", {
                      staticClass: "download-table",
                      attrs: { size: "small", icon: "el-icon-download" },
                      on: {
                        click: function ($event) {
                          return _vm.onDownload("categorySales")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("search-com-company", {
                staticClass: "search-company",
                attrs: {
                  type: _vm.categorySales.type,
                  dateArr: _vm.categorySales.dateArr,
                },
                on: { outputSearchData: _vm.receiveSearchData },
              }),
              _c("data-board-table", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.categorySales.loading,
                    expression: "categorySales.loading",
                  },
                ],
                attrs: {
                  dataList: _vm.categorySales.list,
                  config: _vm.categorySales.config,
                  sortObj: _vm.categorySales.sortObj,
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "table-content-item" }, [
          _c(
            "div",
            { staticClass: "table-content-item-side" },
            [
              _c("h3", { staticClass: "card-title" }, [
                _c(
                  "label",
                  [
                    _vm._v("商品销售量 "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: "已发货之后的，不含退货，退款",
                          placement: "top",
                        },
                      },
                      [_c("i", { staticClass: "el-icon-question" })]
                    ),
                  ],
                  1
                ),
                _vm._m(2),
                _c(
                  "div",
                  { staticClass: "staff-button-list" },
                  [
                    _c("el-button", {
                      staticClass: "download-table",
                      attrs: { size: "small", icon: "el-icon-download" },
                      on: {
                        click: function ($event) {
                          return _vm.onDownload("amount")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("search-com-company", {
                staticClass: "search-company",
                attrs: { type: _vm.amount.type, dateArr: _vm.amount.dateArr },
                on: { outputSearchData: _vm.receiveSearchData },
              }),
              _c(
                "div",
                { attrs: { id: "amount" } },
                [
                  _c("top-sale", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.amount.loading,
                        expression: "amount.loading",
                      },
                    ],
                    attrs: {
                      documentId: "amount",
                      config: _vm.amount.config,
                      dataList: _vm.amount.dataList,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.productOrderCancellation.loading,
                  expression: "productOrderCancellation.loading",
                },
              ],
              staticClass: "table-content-item-side",
            },
            [
              _c("h3", { staticClass: "card-title" }, [
                _c("label", [_vm._v("各商品订单取消、退货退款概况")]),
                _c(
                  "div",
                  { staticClass: "staff-button-list" },
                  [
                    _c("el-button", {
                      staticClass: "download-table",
                      attrs: { size: "small", icon: "el-icon-download" },
                      on: {
                        click: function ($event) {
                          return _vm.onDownload("productOrderCancellation")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("search-com-company", {
                staticClass: "search-company",
                attrs: {
                  type: _vm.productOrderCancellation.type,
                  dateArr: _vm.productOrderCancellation.dateArr,
                },
                on: { outputSearchData: _vm.receiveSearchData },
              }),
              _c("data-board-table", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.productOrderCancellation.loading,
                    expression: "productOrderCancellation.loading",
                  },
                ],
                staticClass: "product-order-cancellation",
                attrs: {
                  dataList: _vm.productOrderCancellation.list,
                  config: _vm.productOrderCancellation.config,
                  sortObj: _vm.productOrderCancellation.sortObj,
                },
              }),
              _vm.productOrderCancellation.page.totalNum >= 11
                ? _c(
                    "div",
                    { staticClass: "page" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          "current-page":
                            _vm.productOrderCancellation.page.pageNo,
                          "pager-count": 5,
                          "page-sizes": [3, 5, 10, 20, 50],
                          "page-size":
                            _vm.productOrderCancellation.page.pageSize,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.productOrderCancellation.page.totalNum,
                        },
                        on: {
                          "size-change": _vm.goodsRefundSizeChange,
                          "current-change": _vm.goodsRefundCurrentChange,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("商品数据看板")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "top-mark" }, [_c("i", [_vm._v("TOP10")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "top-mark" }, [_c("i", [_vm._v("TOP10")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }